import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const navLinks = [
  { label: 'How It Works', sectionIndex: 1 },
  { label: 'AI Agents', sectionIndex: 2 },
  { label: 'Pricing', sectionIndex: 6 },
];

export default function Nav({ ctaUrl, onNavClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    setScrolled(true);
  }, []);

  const handleNav = (index) => {
    onNavClick?.(index);
    setMobileOpen(false);
  };

  return (
    <>
      <motion.nav
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="fixed top-0 left-0 right-0 z-50 bg-[#202020]/90 backdrop-blur-xl border-b border-white/5 shadow-xl"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 sm:h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/14d14dc0100011f20de8b02234a5b726.png" 
              alt="RepUpgrade Logo" 
              className="h-8 w-8 object-contain"
            />
            <span className="font-michroma text-white text-sm tracking-widest uppercase hidden sm:block">
              Rep<span className="text-brand-teal">Upgrade</span>
            </span>
          </div>

          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((item) => (
              <button
                key={item.label}
                onClick={() => handleNav(item.sectionIndex)}
                className="text-xs font-bold uppercase tracking-widest text-white/60 hover:text-white transition-colors duration-200"
              >
                {item.label}
              </button>
            ))}
            <a
              href={ctaUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-4 px-5 py-2 rounded-full bg-brand-teal text-white text-[10px] font-bold uppercase tracking-widest hover:bg-brand-teal/80 transition-all"
            >
              Activate
            </a>
          </div>

          <button
            className="md:hidden p-2 text-white/70"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <SafeIcon name={mobileOpen ? 'FiX' : 'FiMenu'} className="h-5 w-5" />
          </button>
        </div>
      </motion.nav>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}
            className="fixed top-[57px] sm:top-[65px] left-0 right-0 z-40 md:hidden bg-[#181818]/98 backdrop-blur-xl border-b border-white/10 shadow-2xl"
          >
            <div className="px-4 py-3 flex flex-col gap-1">
              {navLinks.map((item, i) => (
                <motion.button
                  key={item.label}
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.2, delay: i * 0.05 }}
                  onClick={() => handleNav(item.sectionIndex)}
                  className="flex items-center justify-between w-full px-4 py-3.5 rounded-xl text-left hover:bg-white/5 border border-transparent hover:border-white/5 transition-all duration-200 group"
                >
                  <span className="font-lexend font-bold text-xs uppercase tracking-widest text-white/60 group-hover:text-white transition-colors duration-200">
                    {item.label}
                  </span>
                  <SafeIcon name="FiChevronRight" className="h-3.5 w-3.5 text-white/20 group-hover:text-brand-teal transition-colors duration-200" />
                </motion.button>
              ))}
              <div className="mt-2 pt-3 border-t border-white/5 pb-1">
                <a
                  href={ctaUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center justify-center gap-2 w-full py-3.5 rounded-xl bg-brand-teal text-white font-lexend font-bold text-xs uppercase tracking-widest hover:bg-brand-teal/80 transition-all duration-200 shadow-lg shadow-brand-teal/20"
                >
                  Activate Your Engine
                  <SafeIcon name="FiArrowRight" className="h-3.5 w-3.5" />
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}